import { cn } from "@/lib/utils";

export function ScrollList({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className="flex flex-row justify-between items-center relative">
      <div className="@[768px]:hidden pointer-events-none absolute left-0 bg-gradient-to-r from-background to-transparent w-[1.5ch] inset-y-0 block h-full" />
      <div className="@[768px]:hidden pointer-events-none absolute right-0 bg-gradient-to-l from-background to-transparent w-[1.5ch] inset-y-0 block h-full" />
      <div
        className={cn(
          "no-scrollbar flex overflow-x-auto @[768px]:overflow-x-hidden @[768px]:overflow-y-auto touch-pan-x pt-2 pb-4 px-2 scroll-px-8 empty:hidden @[768px]:flex-col @[768px]:gap-3 @[768px]:w-full",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
